/* eslint-disable no-script-url */
import React from 'react';
import PropTypes from 'prop-types';
import Link from 'components/Link';
import Image from 'components/Image';
import { getImageFromImageObject } from 'components/Image/utils';
import s from './ListWidget.scss';

function customOnError(e) {
  e.target.onerror = null;
  e.target.src = 'https://static.toiimg.com/photo/25581306.cms';
}

class ListWidget extends React.Component {
  handleCardClick = e => {
    e.preventDefault();
    this.props.onClick(this.props.data);
  };
  render() {
    const { data, isPlaying } = this.props;
    if (!data) {
      return null;
    }
    const { imgWidth = '600' } = data;
    const { imageid = '', imagesize = '123456', imageUrl } = data;
    const { image = {} } = data;
    image.width = imgWidth;
    image.id = imageid || image.id;
    image.version = imagesize || image.version;

    const imageSrc = getImageFromImageObject(image) || imageUrl;
    return (
      <li className={`${s.listItem} ${isPlaying ? s.playing : ''}`}>
        {data.wu !== 'undefined' &&
        data.wu &&
        data.wu.indexOf('/toipodcast/') !== -1 ? (
          <Link
            to={data.wu}
            spa={this.props.isspa}
            onClick={e => this.handleCardClick(e)}
          >
            <figure className={s.image}>
              <div className={s.content}>
                <Image
                  key={data.id}
                  width={imgWidth}
                  src={imageSrc}
                  placeHolderSrc="https://static.toiimg.com/photo/25581306.cms"
                  alt=""
                  lazyload
                  onError={customOnError}
                  offsetVertical="100"
                />
              </div>
              <i className={s.playDuration}>{data.du}</i>
            </figure>
            <div className={s.details}>
              <span className={`${s.smallText} ${s.category}`}>
                {data.ptxt}
              </span>
              <h4 className={s.title}>{data.hl}</h4>
              <span className={s.smallText}>{`${data.upd} | Source: ${
                data.ag
              }`}</span>
            </div>
          </Link>
        ) : (
          // eslint-disable-next-line jsx-a11y/anchor-is-valid
          <Link
            onClick={e => {
              e.preventDefault();
            }}
            className={s.fakeLink}
          >
            <figure className={s.image}>
              <div className={s.content}>
                <Image
                  key={data.id}
                  width={imgWidth}
                  src={imageSrc}
                  placeHolderSrc="https://static.toiimg.com/photo/25581306.cms"
                  alt=""
                  lazyload
                  onError={customOnError}
                  offsetVertical="100"
                />
              </div>
              <i className={s.playDuration}>{data.du}</i>
            </figure>
            <div className={s.details}>
              <span className={`${s.smallText} ${s.category}`}>
                {data.ptxt}
              </span>
              <h4 className={s.title}>{data.hl}</h4>
              <span className={s.smallText}>{`${data.upd} | Source: ${
                data.ag
              }`}</span>
            </div>
          </Link>
        )}
      </li>
    );
  }
}

ListWidget.propTypes = {
  data: PropTypes.shape({}),
  onClick: PropTypes.shape({}),
  isspa: PropTypes.bool,
  isPlaying: PropTypes.bool,
};
ListWidget.defaultProps = {
  data: {},
  onClick: () => {},
  isspa: false,
  isPlaying: false,
};

export default ListWidget;
